var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EditAgency',{attrs:{"agencyIdProp":_vm.currentUser && _vm.currentUser.agencyId ? _vm.currentUser.agencyId : ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }